export let Orientation = {
  Vertical: 'vertical',
  Horizontal: 'horizontal'
}